import { render, staticRenderFns } from "./rightGuide.vue?vue&type=template&id=68aca695&scoped=true"
import script from "./rightGuide.vue?vue&type=script&lang=js"
export * from "./rightGuide.vue?vue&type=script&lang=js"
import style0 from "./rightGuide.vue?vue&type=style&index=0&id=68aca695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aca695",
  null
  
)

export default component.exports